import React from "react";

function ScheduleTile({ faculty_name, course_name, room, campus, time, cls }) {
  return (
    <div className="schedule-tile-container">
      <h3>{course_name}</h3>
      <p>{faculty_name}</p>
      <p>
        {room} ({campus})
      </p>
      <div className="class-container">
        {cls.map((c) => (
          <p key={c._id}>
            {c.program} {c.semester} {c.section}
          </p>
        ))}
      </div>
      <div className="time-container">
        {time.map((time, i) => (
          <p key={time + i}>{time}</p>
        ))}
      </div>
    </div>
  );
}

export default ScheduleTile;
